module.exports = __webpack_public_path__ + "static/media/navigation-arrow-brand-refresh.923371fb.svg";